import * as yup from 'yup'
import { ALL_HTML_TAG_REGEX } from 'Src/constants'

const noHtmlTagValidation = {
  name: 'no-html-tag',
  message: 'Name should not contain any HTML tags',
  test: (text) => !text.match(ALL_HTML_TAG_REGEX)
}

const createGuideFormValidationSchema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required('Name is required')
      .min(3, 'Name should contain at least ${min} characters')
      .test(noHtmlTagValidation),
    content: yup.string().trim().required('Content is required')
  })
  .required()

export default createGuideFormValidationSchema
